import { render, staticRenderFns } from "./GerenciarIpus.vue?vue&type=template&id=c3323932&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "./GerenciarIpus.vue?vue&type=style&index=0&id=c3323932&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3323932",
  null
  
)

export default component.exports